module.exports = __webpack_public_path__ + "img/moon.b1761e7d.png";